export class ElementRendererContract {

    renderElement(tag, css = null, props = null, content = null) {
        throw new Error(`${this.constructor.name}: renderElement(tag, css, props, content) is not implemented.`);
    }

    createView(renderFactory, data = null) {
        throw new Error(`${this.constructor.name}: createView(renderFactory, data) is not implemented.`);
    }

    injectView(view, data = null) {
        throw new Error(`${this.constructor.name}: injectView(view, data) is not implemented.`);
    }

}
